
import { Component, Prop, Vue } from "vue-property-decorator";
import { EventBus } from "@/event-bus";
import { IServicepointUserTable } from "@/entities";
import IconFilter from "@/components/common/icon/IconFilter.vue";
import VueMethods from "@/vue-methods";

@Component({
  name: "filter-user-servicepoints",
  components: {
    IconFilter,
  },
  mixins: [VueMethods],
})
export default class FilterUserServicepoints extends Vue {
  @Prop({ required: false, default: null }) params!: IServicepointUserTable;
  @Prop({ required: false, default: "sidebar-filters" }) sidebarId!: string;
  private visible = false;
  private paramsEdit: IServicepointUserTable = Object.assign({}, this.params);

  get filterLength(): number {
    let length = 0;
    Object.values(this.params).forEach((value) => {
      if (value) {
        length++;
      }
    });
    return length;
  }

  doCleanUp(): void {
    this.paramsEdit = {};
    this.$emit("update:params", Object.assign({}, this.paramsEdit));
    EventBus.$emit("filter-user-servicepoints-table");
  }

  doFilter(): void {
    this.$emit("update:params", Object.assign({}, this.cleanUpEmptyStrings(this.paramsEdit)));
    EventBus.$emit("filter-user-servicepoints-table");
    this.visible = false;
  }
}
